import { FC } from 'react';
import { IconColor, IconProps } from '../types';

export const SettingsIcon: FC<IconProps> = ({
  width = 24,
  height = 24,
  fillColor = IconColor.TEXT_PRIMARY,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.25 20L7.85 16.8C7.63333 16.7167 7.42933 16.6167 7.238 16.5C7.04666 16.3833 6.859 16.2583 6.675 16.125L3.7 17.375L0.949997 12.625L3.525 10.675C3.50833 10.5583 3.5 10.446 3.5 10.338V9.663C3.5 9.55433 3.50833 9.44167 3.525 9.325L0.949997 7.375L3.7 2.625L6.675 3.875C6.85833 3.74167 7.05 3.61667 7.25 3.5C7.45 3.38333 7.65 3.28333 7.85 3.2L8.25 0H13.75L14.15 3.2C14.3667 3.28333 14.571 3.38333 14.763 3.5C14.955 3.61667 15.1423 3.74167 15.325 3.875L18.3 2.625L21.05 7.375L18.475 9.325C18.4917 9.44167 18.5 9.55433 18.5 9.663V10.337C18.5 10.4457 18.4833 10.5583 18.45 10.675L21.025 12.625L18.275 17.375L15.325 16.125C15.1417 16.2583 14.95 16.3833 14.75 16.5C14.55 16.6167 14.35 16.7167 14.15 16.8L13.75 20H8.25ZM11.05 13.5C12.0167 13.5 12.8417 13.1583 13.525 12.475C14.2083 11.7917 14.55 10.9667 14.55 10C14.55 9.03333 14.2083 8.20833 13.525 7.525C12.8417 6.84167 12.0167 6.5 11.05 6.5C10.0667 6.5 9.23733 6.84167 8.562 7.525C7.88666 8.20833 7.54933 9.03333 7.55 10C7.55066 10.9667 7.88833 11.7917 8.563 12.475C9.23766 13.1583 10.0667 13.5 11.05 13.5Z"
        fill={fillColor}
      />
    </svg>
  );
};
